export const emailDomains = [
	"yahoo.com",
	"gmail.com", 
	"google.com", 
	"hotmail.com", 
	"me.com", 
	"aol.com", 
	"mac.com", 
	"live.com", 
	"comcast.com", 
	"googlemail.com", 
	"msn.com", 
	"hotmail.co.uk", 
	"yahoo.co.uk", 
	"facebook.com", 
	"verizon.net", 
	"att.net", 
	"gmz.com", 
	"mail.com"
];


// WEBPACK FOOTER //
// ./src/utils/emailDomains.js